import React from "react";
import { Box, CircularProgress } from "@mui/material";

/**
 * PosPageLoader — a self-contained, centered loading spinner.
 *
 * Fills its parent container and centers a CircularProgress both horizontally
 * and vertically. Intended for page / data-fetch loading states (e.g. on a slow
 * network) without affecting the surrounding layout or styles. Because it only
 * uses a scoped MUI `sx`, it never leaks styling onto sibling elements.
 *
 * @param {Object} props
 * @param {number} [props.size=44] - Diameter of the spinner in px.
 * @param {string} [props.color="#2A71FF"] - Spinner color.
 * @param {string|number} [props.minHeight="240px"] - Minimum height so the
 *   spinner stays vertically centered even when the parent has no fixed height.
 * @returns {JSX.Element}
 */
const PosPageLoader = ({ size = 44, color = "#2A71FF", minHeight = "240px" }) => {
  return (
    <Box
      sx={{
        flex: 1,
        width: "100%",
        height: "100%",
        minHeight,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <CircularProgress size={size} sx={{ color }} />
    </Box>
  );
};

export default PosPageLoader;
